/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CreateProjectVideoEditorProjectsMutationRequest, CreateProjectVideoEditorProjectsMutationResponse } from "../models/CreateProjectVideoEditorProjects";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createProjectVideoEditorProjects } from "../axios/createProjectVideoEditorProjects";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createProjectVideoEditorProjectsMutationKey = () => ["web-app-bff-api", { url: '/video-editor/projects' }] as const

export type CreateProjectVideoEditorProjectsMutationKey = ReturnType<typeof createProjectVideoEditorProjectsMutationKey>

export function createProjectVideoEditorProjectsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateProjectVideoEditorProjectsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createProjectVideoEditorProjectsMutationKey()
        return mutationOptions<CreateProjectVideoEditorProjectsMutationResponse, ResponseErrorConfig<Error>, {data: CreateProjectVideoEditorProjectsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return createProjectVideoEditorProjects(data, config)
          },
        })

}

/**
 * @summary Create a project from a source (response includes creator and published platforms)
 * {@link /video-editor/projects}
 */
export function useCreateProjectVideoEditorProjects<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateProjectVideoEditorProjectsMutationResponse, ResponseErrorConfig<Error>, {data: CreateProjectVideoEditorProjectsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateProjectVideoEditorProjectsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createProjectVideoEditorProjectsMutationKey()

          const baseOptions = createProjectVideoEditorProjectsMutationOptions(config) as UseMutationOptions<CreateProjectVideoEditorProjectsMutationResponse, ResponseErrorConfig<Error>, {data: CreateProjectVideoEditorProjectsMutationRequest}, TContext>
          

          return useMutation<CreateProjectVideoEditorProjectsMutationResponse, ResponseErrorConfig<Error>, {data: CreateProjectVideoEditorProjectsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateProjectVideoEditorProjectsMutationResponse, ResponseErrorConfig<Error>, {data: CreateProjectVideoEditorProjectsMutationRequest}, TContext>
      
}